module.exports = __webpack_public_path__ + "img/microsoft.686655a1.png";